// src/DebugLogs.jsx
import { useEffect } from 'react';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const DebugLogs = () => {
  useEffect(() => {
    fetch(`${API_BASE_URL}/api/debug-logs`)
      .then((res) => res.json())
      .then((data) => {
        console.log("DEBUG LOGS:", data);
      })
      .catch((err) => {
        console.error("Error fetching debug logs:", err);
      });
  }, []);

  return null; // This component doesn't render any visible UI
};

export default DebugLogs;
